import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

const Fullscreen = ({ children }) => (
  <ReactModal
    className="o-fullscreen u-bg-white u-scrollable-y"
    overlayClassName="s-v2"
    contentLabel="Modal"
    isOpen
    ariaHideApp={false}
  >
    {children}
  </ReactModal>
);
Fullscreen.propTypes = {
  children: PropTypes.node.isRequired,
};
Fullscreen.defaultProps = {
};

export default Fullscreen;
